const wordList = {
  '010': [
    'adjacent',
    'albeit',
    'assemble',
    'assembled',
    'assembles',
    'assemblies',
    'assembly',
    'collapses',
    'collapsing',
    'compiling',
    'conceiving',
    'convinces',
    'convincing',
    'depresses',
    'depressing',
    'depression',
    'encounter',
    'encountered',
    'encounters',
    'enormous',
    'persisted',
    'persistence',
    'persistent',
    'persisting',
    'reluctance',
    'reluctant',
    'adjusted',
    'adjusting',
    'adjustment',
    'adjustments',
    'unaltered',
    'amended',
    'amending',
    'amendment',
    'amendments',
    'awareness',
    'compounded',
    'compounding',
    'conflicted',
    'conflicting',
    'consultant',
    'consultants',
    'consulted',
    'consulting',
    'declining',
    'discretion',
    'redrafted',
    'redrafting',
    'enable',
    'enabled',
    'enables',
    'enforcement',
    'enforces',
    'enforcing',
    'evolving',
    'expanded',
    'expanding',
    'expansion',
    'expansive',
    'exposes',
    'exposing',
    'exposure',
    'exposures',
    'external',
    'unlicensed',
    'logician',
    'logicians',
    'objective',
    'perspective',
    'perspectives',
    'precisely',
    'precision',
    'pursuing',
    'rejected',
    'rejecting',
    'rejection',
    'rejections',
    'unstable',
    'sustaining',
    'symbolic',
    'transition',
    'transitions',
    'adapted',
    'adapting',
    'adaptive',
    'unaided',
    'comprises',
    'comprising',
    'confirming',
    'conversion',
    'conversions',
    'converted',
    'converting',
    'denial',
    'denials',
    'denying',
    'disposal',
    'disposes',
    'disposing',
    'dynamic',
    'dynamics',
    'equipment',
    'equipping',
    'extracted',
    'extracting',
    'extraction',
    'foundation',
    'foundations',
    'prohibit',
    'prohibits',
    'quotation',
    'quotations',
    'releases',
    'releasing',
    'reversal',
    'reverses',
    'reversing',
    'reversals',
    'submission',
    'submissions',
    'submitted',
    'submitting',
    'successor',
    'succession',
    'successions',
    'successive',
    'successors',
    'survival',
    'surviving',
    'survivor',
    'survivors',
    'transmission',
    'transmissions',
    'transmitted',
    'transmitting',
    'uniquely',
    'uniqueness',
    'apparent',
    'commitment',
    'commitments',
    'committed',
    'committing',
    'conferring',
    'contrasted',
    'contrasting',
    'contrastive',
    'debated',
    'debating',
    'dimension',
    'dimensions',
    'domestic',
    'domestics',
    'imposes',
    'predicted',
    'predicting',
    'prediction',
    'predictions',
    'projected',
    'projecting',
    'projection',
    'projections',
    'promoted',
    'promoter',
    'promoters',
    'promoting',
    'promotion',
    'promotions',
    'resolving',
    'retaining',
    'retainer',
    'retainers',
    'retention',
    'retentive',
    'statistic',
    'statistics',
    'summation',
    'approaches',
    'approaching',
    'assesses',
    'assessing',
    'assessment',
    'assessments',
    'assuming',
    'assumption',
    'assumptions',
    'conception',
    'consisted',
    'consistent',
    'consisting',
    'created',
    'creating',
    'creation',
    'creations',
    'creative',
    'creator',
    'creators',
    'defining',
    'deriving',
    'distribute',
    'establish',
    'established',
    'exported',
    'exporter',
    'exporters',
    'exporting',
    'financing',
    'occurrence',
    'occurring',
    'percentage',
    'procedure',
    'procedures',
    'proceeded',
    'proceeding',
    'proceedings',
    'requirement',
    'requirements',
    'researches',
    'researching',
    'responded',
    'respondent',
    'respondents',
    'responding',
    'responses',
    'responsive',
    'specific',
    'specifics',
    'restructure',
    'restructured',
    'restructures',
    'unstructured',
    'component',
    'components',
    'consensus',
    'consented',
    'consenting',
    'constraining',
    'contribute',
    'contributes',
    'convention',
    'convening',
    'conventions',
    'deduces',
    'deducing',
    'deduction',
    'deductions',
    'emphatic',
    'ensuring',
    'excluded',
    'excluding',
    'exclusion',
    'exclusions',
    'exclusive',
    'location',
    'locations',
    'negating',
    'proportion',
    'proportions',
    'unpublished',
    'reacted',
    'reacting',
    'reaction',
    'reactions',
    'reactive',
    'reactor',
    'reactors',
    'reliance',
    'reliant',
    'relying',
    'removal',
    'removals',
    'removing',
    'schematic',
    'sequential',
    'sufficient',
    'abandon',
    'abandoned',
    'abandons',
    'appendix',
    'appended',
    'appending',
    'uncharted',
    'conformance',
    'conforming',
    'conformist',
    'conformists',
    'denoted',
    'denoting',
    'detected',
    'detecting',
    'detection',
    'detective',
    'detectives',
    'detector',
    'detectors',
    'displacement',
    'displaces',
    'displacing',
    'dramatic',
    'exhibit',
    'exhibits',
    'intenseness',
    'intension',
    'prospective',
    'restoring',
    'revises',
    'revising',
    'revision',
    'revisions',
    'reschedule',
    'rescheduled',
    'reschedules',
    'unscheduled',
    'thematic',
    'assurance',
    'assuring',
    'attaining',
    'attainment',
    'attainments',
    'coherent',
    'coherence',
    'commences',
    'commencement',
    'commencing',
    'concurrent',
    'confining',
    'devices',
    'devoted',
    'devoting',
    'devotion',
    'devotions',
    'diminish',
    'diminished',
    'distorted',
    'distorting',
    'distortion',
    'distortions',
    'eroded',
    'eroding',
    'erosion',
    'unfounded',
    'inherent',
    'maturing',
    'refinement',
    'refinements',
    'refining',
    'relaxes',
    'relaxing',
    'restraining',
    'suspended',
    'suspending',
    'suspension',
    'achievement',
    'achievements',
    'achieving',
    'acquire',
    'acquired',
    'acquires',
    'affected',
    'affecting',
    'affective',
    'assistance',
    'assistant',
    'assistants',
    'assisted',
    'assisting',
    'commission',
    'commissioned',
    'commissions',
    'computer',
    'computed',
    'computers',
    'computing',
    'concluded',
    'concluding',
    'conclusion',
    'conclusions',
    'conclusive',
    'conducted',
    'conducting',
    'constructed',
    'constructing',
    'construction',
    'constructions',
    'constructive',
    'consumer',
    'consumers',
    'consuming',
    'consumption',
    'uncultured',
    'designer',
    'designers',
    'designing',
    'distinction',
    'distinctions',
    'distinctive',
    'distinctly',
    'equated',
    'equating',
    'equation',
    'equations',
    'refocus',
    'refocused',
    'refocussed',
    'uninjured',
    'maintaining',
    'abnormal',
    'obtaining',
    'perceiving',
    'perception',
    'perceptions',
    'potential',
    'resided',
    'residing',
    'resourceful',
    'restricted',
    'restricting',
    'restriction',
    'restrictions',
    'restrictive',
    'securely',
    'securing',
    'selected',
    'selecting',
    'selection',
    'selections',
    'selective',
    'selector',
    'selectors',
    'strategic',
    'tradition',
    'traditions',
    'transference',
    'transferring',
    'abstraction',
    'abstractions',
    'acknowledge',
    'acknowledged',
    'assigning',
    'assignment',
    'assignments',
    'attaches',
    'attaching',
    'attachment',
    'attachments',
    'citation',
    'citations',
    'displaying',
    'edition',
    'editions',
    'enhancement',
    'enhances',
    'enhancing',
    'exceeded',
    'exceeding',
    'explicit',
    'migration',
    'migrations',
    'preceded',
    'preceding',
    'presuming',
    'presumption',
    'presumptions',
    'recover',
    'recovered',
    'recovers',
    'revealing',
    'transforming',
    'transported',
    'transporter',
    'transporters',
    'transporting',
  ],
  '01': [
    'collapse',
    'collapsed',
    'compile',
    'compiled',
    'compiles',
    'conceive',
    'conceived',
    'conceives',
    'convince',
    'convinced',
    'depress',
    'depressed',
    'persist',
    'persists',
    'whereby',
    'adjust',
    'adjusts',
    'amend',
    'amends',
    'aware',
    'consult',
    'consults',
    'decline',
    'declined',
    'declines',
    'discrete',
    'redraft',
    'enforce',
    'enforced',
    'evolve',
    'evolved',
    'evolves',
    'expand',
    'expands',
    'expose',
    'exposed',
    'precise',
    'pursue',
    'pursued',
    'pursues',
    'pursuit',
    'pursuits',
    'sustain',
    'sustained',
    'sustains',
    'whereas',
    'adapt',
    'adapts',
    'comprise',
    'comprised',
    'confirm',
    'confirmed',
    'confirms',
    'deny',
    'denied',
    'denies',
    'dispose',
    'disposed',
    'equip',
    'equipped',
    'equips',
    'release',
    'released',
    'reverse',
    'reversed',
    'submit',
    'survive',
    'survived',
    'survives',
    'transmit',
    'transmits',
    'unique',
    'commit',
    'commits',
    'confer',
    'conferred',
    'confers',
    'debate',
    'debates',
    'despite',
    'predict',
    'predicts',
    'promote',
    'promotes',
    'regime',
    'regimes',
    'resolve',
    'resolved',
    'resolves',
    'retain',
    'retained',
    'retains',
    'unstressed',
    'approach',
    'approached',
    'assess',
    'assessed',
    'assume',
    'assumed',
    'assumes',
    'consist',
    'consists',
    'create',
    'creates',
    'define',
    'defined',
    'defines',
    'derive',
    'derived',
    'derives',
    'occur',
    'occurred',
    'occurs',
    'percent',
    'proceed',
    'proceeds',
    'researched',
    'respond',
    'responds',
    'response',
    'consent',
    'consents',
    'constrain',
    'constrained',
    'constrains',
    'constraint',
    'constraints',
    'convene',
    'convenes',
    'convened',
    'deduce',
    'deduced',
    'ensure',
    'ensured',
    'ensures',
    'exclude',
    'excludes',
    'negate',
    'negates',
    'react',
    'reacts',
    'rely',
    'relied',
    'relies',
    'remove',
    'removed',
    'removes',
    'technique',
    'techniques',
    'append',
    'appends',
    'conform',
    'conformed',
    'conforms',
    'denote',
    'denotes',
    'detect',
    'detects',
    'displace',
    'displaced',
    'restore',
    'restored',
    'restores',
    'revise',
    'revised',
    'assure',
    'assured',
    'assures',
    'attain',
    'attained',
    'attains',
    'behalf',
    'commence',
    'commenced',
    'confine',
    'confined',
    'device',
    'devote',
    'devotes',
    'distort',
    'distorts',
    'erodes',
    'mature',
    'matured',
    'matures',
    'refine',
    'refined',
    'refines',
    'relax',
    'relaxed',
    'restrain',
    'restrained',
    'restrains',
    'restraint',
    'restraints',
    'suspend',
    'suspends',
    'achieve',
    'achieved',
    'achieves',
    'affect',
    'affects',
    'assist',
    'assists',
    'compute',
    'conclude',
    'concludes',
    'conducts',
    'consume',
    'consumed',
    'consumes',
    'design',
    'designed',
    'designs',
    'distinct',
    'equate',
    'equates',
    'maintain',
    'maintained',
    'maintains',
    'obtain',
    'obtained',
    'obtains',
    'perceive',
    'perceived',
    'perceives',
    'reside',
    'resides',
    'restrict',
    'restricts',
    'secure',
    'secured',
    'secures',
    'select',
    'selects',
    'assign',
    'assigned',
    'assigns',
    'attach',
    'attached',
    'display',
    'displayed',
    'displays',
    'diverse',
    'domain',
    'domains',
    'enhance',
    'enhanced',
    'estate',
    'estates',
    'exceed',
    'exceeds',
    'precede',
    'precedes',
    'presume',
    'presumed',
    'presumes',
    'reveal',
    'revealed',
    'reveals',
    'transformed',
    'transforms',
  ],
  '10': [
    'colleague',
    'colleagues',
    'levy',
    'levies',
    'panel',
    'panelled',
    'panels',
    'poses',
    'posing',
    'alter',
    'altered',
    'alters',
    'challenge',
    'challenged',
    'clauses',
    'drafted',
    'drafting',
    'image',
    'licence',
    'license',
    'licensed',
    'logic',
    'margin',
    'margins',
    'mental',
    'notion',
    'notions',
    'stable',
    'styling',
    'stylish',
    'symbol',
    'symbols',
    'target',
    'targets',
    'transit',
    'transits',
    'version',
    'versions',
    'aided',
    'aiding',
    'channel',
    'channelled',
    'channels',
    'classic',
    'classics',
    'couple',
    'coupled',
    'coupling',
    'couples',
    'filing',
    'global',
    'graded',
    'grading',
    'quoted',
    'quoting',
    'thesis',
    'theses',
    'topic',
    'topics',
    'civil',
    'coded',
    'coding',
    'cycle',
    'cycled',
    'cycles',
    'cyclic',
    'error',
    'errors',
    'ethnic',
    'granted',
    'granting',
    'label',
    'labeled',
    'labelled',
    'labels',
    'option',
    'options',
    'phases',
    'phasing',
    'prior',
    'series',
    'status',
    'stresses',
    'stressful',
    'stressing',
    'summing',
    'concept',
    'concepts',
    'context',
    'data',
    'export',
    'exports',
    'factor',
    'factored',
    'factors',
    'function',
    'functioned',
    'functions',
    'issue',
    'issued',
    'issues',
    'labour',
    'labor',
    'labored',
    'labors',
    'laboured',
    'labours',
    'legal',
    'major',
    'method',
    'methods',
    'processed',
    'section',
    'sectioned',
    'sections',
    'sector',
    'sectors',
    'sources',
    'sourcing',
    'structure',
    'structured',
    'structures',
    'vary',
    'varied',
    'varies',
    'comment',
    'comments',
    'constant',
    'constants',
    'coring',
    'funded',
    'funder',
    'funders',
    'funding',
    'instance',
    'layer',
    'layered',
    'layers',
    'linkage',
    'linking',
    'minor',
    'minors',
    'partner',
    'partners',
    'publish',
    'published',
    'scheming',
    'sequence',
    'sequenced',
    'sexes',
    'shifted',
    'shifting',
    'valid',
    'volume',
    'volumes',
    'bias',
    'biased',
    'charted',
    'charting',
    'crucial',
    'drama',
    'dramas',
    'pluses',
    'prospect',
    'prospects',
    'random',
    'schedule',
    'scheduled',
    'schedules',
    'tension',
    'tensely',
    'tenser',
    'tensest',
    'tensions',
    'via',
    'bulky',
    'ceaseless',
    'ceases',
    'ceasing',
    'ethic',
    'ethics',
    'founded',
    'founder',
    'founders',
    'founding',
    'passive',
    'portion',
    'portions',
    'rigid',
    'routed',
    'routing',
    'teaming',
    'trigger',
    'triggered',
    'triggers',
    'vision',
    'visions',
    'chapter',
    'chapters',
    'credit',
    'credits',
    'culture',
    'cultured',
    'cultures',
    'feature',
    'featured',
    'features',
    'final',
    'finals',
    'focus',
    'focused',
    'focussed',
    'injure',
    'injured',
    'injures',
    'item',
    'items',
    'journal',
    'journals',
    'normal',
    'purchase',
    'purchased',
    'ranges',
    'ranging',
    'region',
    'regions',
    'resource',
    'resourced',
    'seeking',
    'abstracts',
    'author',
    'authored',
    'authors',
    'bonded',
    'bonding',
    'briefing',
    'briefly',
    'cited',
    'citing',
    'edit',
    'edits',
    'expert',
    'experts',
    'gender',
    'genders',
    'index',
    'indexed',
    'lecture',
    'lectured',
    'lectures',
    'migrant',
    'migrants',
    'motive',
    'motives',
    'neutral',
    'taping',
    'traces',
    'tracing',
  ],
  '100': [
    'panelling',
    'altering',
    'challenger',
    'challengers',
    'challenges',
    'challenging',
    'energy',
    'energies',
    'entity',
    'entities',
    'imagery',
    'images',
    'licences',
    'licensing',
    'licenses',
    'logical',
    'logically',
    'marginal',
    'medical',
    'mentally',
    'monitor',
    'monitored',
    'monitors',
    'primacy',
    'sustenance',
    'targeted',
    'targeting',
    'transited',
    'transiting',
    'channelling',
    'chemical',
    'chemically',
    'chemicals',
    'classical',
    'definite',
    'infinite',
    'globally',
    'inference',
    'media',
    'solely',
    'topical',
    'ultimate',
    'visible',
    'visibly',
    'annual',
    'cyclical',
    'implement',
    'implements',
    'labelling',
    'obvious',
    'occupant',
    'occupants',
    'optional',
    'principal',
    'principally',
    'subsequent',
    'summary',
    'summaries',
    'summarise',
    'summarised',
    'analyst',
    'area',
    'areas',
    'benefit',
    'benefits',
    'contracted',
    'contracting',
    'evident',
    'evidenced',
    'evidence',
    'factoring',
    'formula',
    'formulas',
    'functional',
    'functioning',
    'issuing',
    'labouring',
    'legally',
    'period',
    'periods',
    'policy',
    'policies',
    'principle',
    'principled',
    'principles',
    'processes',
    'processing',
    'researcher',
    'researchers',
    'sectioning',
    'similar',
    'structural',
    'structuring',
    'theorist',
    'theorists',
    'variance',
    'variant',
    'variants',
    'varying',
    'commented',
    'commenting',
    'constancy',
    'constantly',
    'corporates',
    'document',
    'documents',
    'dominance',
    'dominant',
    'emphasis',
    'emphasise',
    'emphasised',
    'immigrant',
    'immigrants',
    'instances',
    'layering',
    'linkages',
    'maximum',
    'negative',
    'negatives',
    'physical',
    'publisher',
    'publishers',
    'publishes',
    'publishing',
    'register',
    'registered',
    'registers',
    'sequences',
    'sequencing',
    'sexism',
    'sexual',
    'technical',
    'validate',
    'validly',
    'biases',
    'biasing',
    'clarity',
    'complement',
    'complements',
    'crucially',
    'currency',
    'currencies',
    'dramatist',
    'nuclear',
    'radical',
    'radically',
    'radicals',
    'randomly',
    'randomness',
    'scheduling',
    'terminal',
    'terminals',
    'vehicle',
    'vehicles',
    'virtual',
    'visual',
    'visually',
    'conversely',
    'ethical',
    'integral',
    'manual',
    'manuals',
    'medium',
    'minimal',
    'mutual',
    'passively',
    'rigidly',
    'spherical',
    'triggering',
    'violate',
    'violates',
    'consequent',
    'consequence',
    'credited',
    'crediting',
    'creditor',
    'creditors',
    'cultural',
    'element',
    'elements',
    'featuring',
    'finally',
    'focuses',
    'focusing',
    'focussing',
    'injuries',
    'injuring',
    'injury',
    'positive',
    'previous',
    'purchaser',
    'purchasers',
    'purchases',
    'purchasing',
    'regional',
    'relevant',
    'relevance',
    'residence',
    'resident',
    'residents',
    'resources',
    'resourcing',
    'insecure',
    'strategy',
    'strategies',
    'strategist',
    'strategists',
    'accurate',
    'aggregate',
    'authoring',
    'brevity',
    'capable',
    'edited',
    'editing',
    'editor',
    'editors',
    'expertly',
    'flexible',
    'ignorant',
    'ignorance',
    'incidence',
    'incident',
    'incidents',
    'indexes',
    'indexing',
    'interval',
    'intervals',
    'lecturer',
    'lecturers',
    'lecturing',
    'minimum',
    'ministry',
    'ministered',
    'ministering',
    'ministries',
    'precedence',
    'precedent',
    'subsidy',
    'subsidies',
    'traceable',
  ],
  '001': [
    'unresolved',
    'reassess',
    'reassessed',
    'redefine',
    'redefined',
    'redefines',
    'uninvolved',
    'reoccur',
    'reoccurred',
    'reoccurs',
  ],
};

export default wordList;



// WEBPACK FOOTER //
// ./data/expanded-words.js